// Sticky "slide-over" section stacking.
// For each section flagged [data-sticky-stack], wrap it and the section above it
// in a .sticky-stack-group. The section above is pinned (sticky) and the flagged
// one slides up over it. Wrapping limits the pin to the pair, so the pinned
// section releases as the slide-over finishes instead of bleeding over later
// sections. Pure CSS scroll — no JS animation.
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Inject a stylesheet (once) whose rules use !important so they beat the
  // theme's `[role=main] .shopify-section { position: relative }`. !important
  // always wins over a non-important declaration regardless of specificity,
  // and a stylesheet rule can't be wiped the way an inline style can.
  function ensureStyle() {
    if (document.getElementById('sticky-stack-style')) return;
    var s = document.createElement('style');
    s.id = 'sticky-stack-style';
    s.textContent =
      // Clip the group so the pinned hero (and its overflowing image / the theme's
      // rounded-corner ::before) can't bleed below the group into the next
      // section's transparent areas. `clip` does not create a scroll container, so
      // it does not break the sticky pin.
      '.sticky-stack-group{overflow:clip!important}' +
      '.sticky-stack-group .sticky-stack-prev{position:sticky!important;top:0!important;z-index:0!important}' +
      // High z-index so the collage's opaque background decisively covers the hero
      // and the hero's own z-index:1 overlay content.
      '.sticky-stack-group .sticky-stack-over{position:relative!important;z-index:2!important}' +
      // Square the sliding section's BOTTOM corners. The theme rounds the bottom
      // (~border-radius), and with overflow:clip those rounded corners are
      // transparent — the hero behind shows through the gaps. Keep the TOP corners
      // rounded (intended look as it slides over).
      '.sticky-stack-group .sticky-stack-over{border-end-start-radius:0!important;border-end-end-radius:0!important}';
    document.head.appendChild(s);
  }

  function wrapOne(flag) {
    var current = flag.closest('.shopify-section');
    if (!current) return;

    // Already wrapped.
    if (current.parentNode && current.parentNode.classList.contains('sticky-stack-group')) return;

    var prev = current.previousElementSibling;
    if (!prev || !prev.classList.contains('shopify-section')) return;

    var group = document.createElement('div');
    group.className = 'sticky-stack-group';
    prev.parentNode.insertBefore(group, prev);
    group.appendChild(prev);
    group.appendChild(current);

    ensureStyle();
    prev.classList.add('sticky-stack-prev');
    current.classList.add('sticky-stack-over');

    // The theme's `body { overflow-x: hidden }` silently disables position:
    // sticky on descendants. `clip` prevents horizontal scroll WITHOUT creating
    // a scroll container, so the pin works. !important inline = guaranteed win.
    document.body.style.setProperty('overflow-x', 'clip', 'important');
  }

  function unwrapAll() {
    document.querySelectorAll('.sticky-stack-group').forEach(function (group) {
      var parent = group.parentNode;
      while (group.firstChild) parent.insertBefore(group.firstChild, group);
      parent.removeChild(group);
    });
    document.querySelectorAll('.sticky-stack-prev').forEach(function (n) {
      n.classList.remove('sticky-stack-prev');
    });
    document.querySelectorAll('.sticky-stack-over').forEach(function (n) {
      n.classList.remove('sticky-stack-over');
    });
    document.body.style.removeProperty('overflow-x');
  }

  function apply() {
    if (REDUCE.matches) return;
    document.querySelectorAll('[data-sticky-stack]').forEach(wrapOne);
  }

  function reinit() {
    unwrapAll();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Theme editor: sections get re-rendered/reordered, so rebuild the wrappers.
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, reinit);
  });
})();
